// extracted by mini-css-extract-plugin
module.exports = {"Map":"map_Map__xGIBC"};